<template>
	<div>
        <ValidationObserver ref="formModalValidate">
            <div class="row">
                <div class="col-12">
                    <ValidationProvider name="type" rules="required" v-slot="{ valid, errors }">
                        <b-form-group>
                            <label>{{ $t('staff') + ' ' + $t('documents') }}</label>
                            <parameter-selectbox v-model="form.type" code="staff_document_types"
                                sort="id" :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="file" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('documents_upload')">
                            <div class="d-flex custom-file-upload">
                                <b-form-file v-model="form.file" :state="errors[0] ? false : null"
                                    :placeholder="$t('select_file')" :drop-placeholder="$t('drop_file')"
                                    ref="fileInput" multiple></b-form-file>
                                <b-button variant="outline-secondary"
                                    @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse')
                                    }}</b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]">
                            </div>
                            <div class="alert alert-info mt-2">{{ $t('warning_file') }}</div>
                        </b-form-group>
                    </ValidationProvider>
                    <ValidationProvider name="explanation" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('explanation')">
                            <b-input-group class="mb-1">
                                <b-form-input v-model="form.explanation"
                                    :state="errors[0] ? false : null" />
                            </b-input-group>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
            </div>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary"
                          @click="createForm"
                          :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
	</div>
</template>

<script>
	// Components
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue";

    // Services
    import StaffService from "@/services/StaffService";

	// Other
	import {ValidationProvider, ValidationObserver} from "vee-validate"

	export default {
		components: {
            ParameterSelectbox,

            ValidationProvider,
            ValidationObserver,
		},
        props: {
            formId: {
                type: [Number, String]
            }
        },
		data() {
			return {
				form: {},
				formLoading: false,
			}
		},
		methods: {
			async createForm() {
				const isValid = await this.$refs.formModalValidate.validate();
				if (isValid) {
					this.formLoading = true;
                    const formData = new FormData();
                    formData.append("type", this.form.type);
                    formData.append("explanation", this.form.explanation);
                    formData.append("file", this.form.file[0]);
                    formData.append("staff_id", this.formId);
					StaffService.fileUpload(formData)
					             .then(response => {
						             this.$toast.success(this.$t('api.' + response.data.message));
						             this.$emit('createFormSuccess', true);
					             })
					             .catch(e => {
						             this.showErrors(e, this.$refs.formModalValidate);
					             })
					             .finally(() => {
						             this.formLoading = false
					             })
				}
			}
		}
	}
</script>

